



















































































import {
  DadosGeraisProcessamento,
  ItemProcessamentoFilaMensagem,
  ProcessamentoFilaMensagensService,
  StatusItemProcessamentoFilaMensagem,
  StatusProcessamentoFilaMensagem,
} from "@/services/processamentoFilaMensagem.service";
import DataTable from "@/shared/components/data-table.vue";
import Modal from "@/shared/components/modal.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import JsonViewer from "./Json.vue";

@Component({
  components: { Modal, DataTable, Tooltip, JsonViewer },
})
export default class Processar extends Vue {
  processamento: DadosGeraisProcessamento | null = null;
  apenasPendentes = false;
  mostrarSucesso = false;
  loading = false;

  promise: Promise<ItemProcessamentoFilaMensagem[]> | null = null;
  headers = [
    { value: "ordem", text: "Ordem" },
    { value: "tipo", text: "Tipo" },
    { value: "jsonOriginal", text: "Json Original", sortable: false },
    { value: "jsonAlterado", text: "Json Alterado", sortable: false },
    { value: "status", text: "Status" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  status = {
    1: "Pendente",
    2: "Processado",
    3: "Ignorado",
    4: "Erro",
  };

  //Computed
  get nome() {
    return this.processamento?.consultor?.nome || "";
  }
  get idConsultor() {
    return this.processamento?.consultor.idConsultor.toString() || "";
  }
  get quantidadeRegistros() {
    return this.processamento?.processamento?.quantidadeTotal || 0;
  }
  get podeProcessar() {
    const quantidadePendentesOuErro =
      (this.processamento?.processamento.quantidadePendente || 0) +
      (this.processamento?.processamento.quantidadeErro || 0);

    return (
      (this.processamento?.processamento.status ==
        StatusProcessamentoFilaMensagem.Criado ||
        this.processamento?.processamento.status ==
        StatusProcessamentoFilaMensagem.Erro) &&
      !!quantidadePendentesOuErro
    );
  }

  get statusGeral() {
    switch (this.processamento?.processamento.status) {
      case 1:
        return "Criado";
      case 2:
        return "Processando";
      case 3:
        return "Finalizado";
      case 4:
        return "Erro";
      default:
        return "";
    }
  }

  mounted() {
    this.fetchProcessamento();
  }

  timeout?: number;

  @Watch("apenasPendentes")
  @Watch("$route.params", { deep: true })
  private async fetchProcessamento() {
    const params = this.$route.params;
    const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;

    if (this.timeout) clearTimeout(this.timeout);
    await (this.promise = ProcessamentoFilaMensagensService.obterProcessamento(
      idProcessamentoFilaMensagem
    )
      .then((dados) => {
        if (
          dados.processamento.status ==
          StatusProcessamentoFilaMensagem.Processando
        ) {
          this.timeout = setTimeout(this.fetchProcessamento, 10000);
        }

        return dados;
      })
      .then((dados) => (this.processamento = dados).processamento.items)
      .then((lista) => {
        if (!this.apenasPendentes) return lista;
        else
          return lista.filter(
            (x) =>
              x.status == StatusItemProcessamentoFilaMensagem.Pendente ||
              x.status == StatusItemProcessamentoFilaMensagem.Erro
          );
      }));
  }

  ignorar(item: ItemProcessamentoFilaMensagem) {
    const params = this.$route.params;
    const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;

    ProcessamentoFilaMensagensService.ignorarProcesso(
      idProcessamentoFilaMensagem,
      item.idItemProcessamentoFilaMensagem
    ).then(this.fetchProcessamento);
  }

  incluir(item: ItemProcessamentoFilaMensagem) {
    const params = this.$route.params;
    const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;

    ProcessamentoFilaMensagensService.incluirProcesso(
      idProcessamentoFilaMensagem,
      item.idItemProcessamentoFilaMensagem
    ).then(this.fetchProcessamento);
  }

  iniciarProcessamento() {
    const params = this.$route.params;
    const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;

    this.loading = true;
    ProcessamentoFilaMensagensService.iniciarProcessamento(
      idProcessamentoFilaMensagem
    )
      .then(() => (this.mostrarSucesso = true))
      .then(this.fetchProcessamento)
      .finally(() => (this.loading = false));
  }

  voltar() {
    const params = {
      idConsultor: this.processamento?.consultor?.idConsultor?.toString() || "",
    };
    this.$router.replace({ name: "filamensagens", params: params });
  }

  verModal(item: ItemProcessamentoFilaMensagem, tipo: string) {
    this.$router.push({
      name: "verjsonprocessamento",
      params: {
        ...this.$route.params,
        idItemProcessamentoFilaMensagem: item.idItemProcessamentoFilaMensagem,
        campo: tipo,
      },
    });
  }

  verErro(item: ItemProcessamentoFilaMensagem) {
    this.$router.push({
      name: "erroprocessamentofilamensagem",
      params: {
        idItemProcessamentoFilaMensagem: item.idItemProcessamentoFilaMensagem,
      },
    });
  }

  verConsultor() {
    const route = this.$router.resolve({
      name: "consultores",
      params: { idConsultor: this.idConsultor },
    });

    window.open(route.href, "_blank");
  }
}
